module.exports = __webpack_public_path__ + "img/PetsyLogo.42c822e5.png";